export default __webpack_public_path__ + "static/media/50_photo.41d00d3b.jpg";